export default {"src":"/_next/static/media/instagram.728a7f89.svg","height":24,"width":24};